// Types
import { GetConferencesResults } from '@typings/operations';

export default (conferences: GetConferencesResults[], year: number) =>
  conferences.filter(item => item.relatedRotaryYear === year);
